import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=b9af6a82&"
import script from "./PageSection.vue?vue&type=script&lang=ts&"
export * from "./PageSection.vue?vue&type=script&lang=ts&"
import style0 from "./PageSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports